import React from "react";
import { AccessKeyCreateResponse } from "../../api/models/access-key-model";
import IconifyIcon from "../IconifyIcon";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";

interface InvitationCardGuardProps {
  selectedAccessKey: AccessKeyCreateResponse | null;
  onPress: () => void;
  style?: React.CSSProperties;
}

const InvitationCardGuard = ({
  selectedAccessKey,
  onPress,
  style,
}: InvitationCardGuardProps) => {
  const labels = useAppSelector(selectLabels);

  const isVerifiedVisitor = selectedAccessKey?.verified_visitor?.name || null;
  const isOtherProvider =
    selectedAccessKey?.one_time_visitor?.provider_name || null;
  const isProvider =
    selectedAccessKey?.one_time_visitor?.provider?.name || null;
  const isOneTimeVisitor = selectedAccessKey?.one_time_visitor?.name || null;
  const InvName = isVerifiedVisitor
    ? isVerifiedVisitor
    : isOtherProvider
    ? isOtherProvider
    : isProvider
    ? isProvider
    : isOneTimeVisitor
    ? isOneTimeVisitor
    : "";

  return (
    <div className="card border-box flex gap-4" style={style} onClick={onPress}>
      <div className="w-70 border-box p-4">
        <div className="w-100 border-box flex align-items-center justify-content-between">
          <div className="w-100 flex align-items-center">
            <p className="font-16 font-w-700 subtitle-color">{InvName}</p>
          </div>
        </div>
        <div className="w-100 border-box flex align-items-center mt-5">
          <div className="flex align-items-center" style={{ minWidth: 40 }}>
            {selectedAccessKey?.access_key_type === "provider" &&
            selectedAccessKey?.one_time_visitor?.provider ? (
              <IconifyIcon
                icon={
                  selectedAccessKey?.one_time_visitor?.provider?.logo_url ||
                  "carbon:no-image"
                }
                style={{ fontSize: 34 }}
                className={
                  !selectedAccessKey?.one_time_visitor?.provider?.logo_url
                    ? "title-color"
                    : ""
                }
              />
            ) : (
              <>
                {selectedAccessKey?.one_time_visitor?.provider_name ? (
                  <IconifyIcon
                    icon={"carbon:no-image"}
                    style={{ fontSize: 34 }}
                    className="title-color"
                  />
                ) : (
                  <IconifyIcon icon={"arcticons:qr"} style={{ fontSize: 34 }} />
                )}
              </>
            )}
          </div>
          <div className="pl-2" style={{ width: "calc(100% - 40px)" }}>
            <p className="font-14 subtitle-color">
              {selectedAccessKey?.created?.name}
            </p>
            <p className="font-12 subtitle-color mt-2">
              {selectedAccessKey?.unit?.name}
            </p>
          </div>
        </div>
      </div>
      <div className="w-30 flex flex-dir-col justify-content-between border-box p-4">
        <div className="w-100 flex align-items-center justify-content-center">
          {selectedAccessKey?.access_key_type === "frequent" && (
            <p className="font-12 subtitle-color font-w-500">
              {labels.recurrent}
            </p>
          )}
          {selectedAccessKey?.access_key_type === "visitor" && (
            <p className="font-12 subtitle-color font-w-500">
              {labels.visitor}
            </p>
          )}
          {selectedAccessKey?.access_key_type === "provider" && (
            <p className="font-12 subtitle-color font-w-500">
              {labels.provider}
            </p>
          )}
        </div>
        <div className="flex flex-dir-col align-items-center">
          {selectedAccessKey?.daleted_at ? (
            <>
              <IconifyIcon
                icon={"f7:trash-fill"}
                className="title-color mb-1"
              />
              <p className="font-12 subtitle-color">
                {labels.invitation_deleted}
              </p>
            </>
          ) : (
            <>
              {selectedAccessKey?.last_transaction_type === null && (
                <>
                  <IconifyIcon
                    icon={"streamline:mail-send-envelope"}
                    className="title-color mb-1"
                  />
                  <p className="font-12 subtitle-color">{labels.not_used}</p>
                </>
              )}
              {selectedAccessKey?.last_transaction_type &&
                selectedAccessKey?.last_transaction_type?.type ===
                  "entrance" && (
                  <>
                    <IconifyIcon
                      icon={"entypo:login"}
                      className="title-color mb-1"
                    />
                    <p className="font-12 subtitle-color">{labels.entrance}</p>
                  </>
                )}
              {selectedAccessKey?.last_transaction_type &&
                selectedAccessKey?.last_transaction_type?.type === "exit" && (
                  <>
                    <IconifyIcon
                      icon={"entypo:log-out"}
                      className="title-color mb-1"
                    />
                    <p className="font-12 subtitle-color">{labels.exit}</p>
                  </>
                )}
              {selectedAccessKey?.last_transaction_type &&
                selectedAccessKey?.last_transaction_type?.type === "try" && (
                  <>
                    <IconifyIcon
                      icon={"entypo:block"}
                      className="title-color mb-1"
                    />
                    <p className="font-12 subtitle-color">
                      {labels.not_authorized_ak_one}
                    </p>
                  </>
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvitationCardGuard;
